// The bots' bees for Android's notifications and icon shortcuts, and both phones' share sheets
// (Android's Direct Share, iOS's suggestions and share extension: ios/App/App/ShareBridge.swift). The bee is drawn only
// in the web app (components/bees/beeSvg.js, beePng.js), so it draws each of the person's bots as a
// small picture and leaves it for the native side in the app's preferences (Capacitor
// Preferences, group "CapacitorStorage"), where BotConversations.java takes it: the same
// bee as in the app, also for a push that comes while the app is closed.
import { Preferences } from '@capacitor/preferences';
import { HONEY, speciesForBots } from '../components/bees/beeSvg';
import { beePng } from '../components/bees/beePng';

const SIGS_KEY = 'bb_face_sigs';
export const faceKey = (id) => `bb_face_${id}`;
export const DEFAULT_FACE = 'default';

/** Every face to keep: each bot's, the queen's and a plain bee for bots not drawn yet. */
export function facesFor(mine) {
  const bots = mine?.bots || [];
  const species = speciesForBots(bots);
  const faces = bots.map((b) => ({ id: b.id, species: species[b.id], color: b.avatar_color || HONEY }));
  if (mine?.queen?.id) faces.push({ id: mine.queen.id, species: 'kralovna', color: HONEY });
  faces.push({ id: DEFAULT_FACE, species: 'robotnica', color: HONEY });
  return faces;
}

/** Draws the faces that changed since last time and forgets those of bots that are gone. */
export async function saveFaces(mine) {
  const faces = facesFor(mine);
  let sigs = {};
  try { sigs = JSON.parse((await Preferences.get({ key: SIGS_KEY })).value || '{}'); } catch { sigs = {}; }
  const next = {};
  for (const face of faces) {
    const sig = `${face.species}|${face.color}`;
    next[face.id] = sig;
    if (sigs[face.id] === sig) continue;
    try {
      await Preferences.set({ key: faceKey(face.id), value: await beePng(face) });
    } catch {
      delete next[face.id];  // drawn next time
    }
  }
  for (const id of Object.keys(sigs)) {
    if (!(id in next)) await Preferences.remove({ key: faceKey(id) });
  }
  await Preferences.set({ key: SIGS_KEY, value: JSON.stringify(next) });
}
